import { Routes, Route, useNavigate } from 'react-router-dom';
import './App.css';
import LoginPage from './routes/Login/LoginPage';
import QrLoginPage from './routes/Login/QrLoginPage'
import PrivacyPage from './routes/Login/PrivacyPage';
import TermsPage from './routes/Login/TermsPage';
import UnitPage from './UnitsNav/UnitPage';
import RedoPage from './routes/Redo/RedoPage';
import Unit1 from './Unit1/Unit1Nav/Unit1Navigation';
import Unit2 from './Unit2/Unit2Nav/Unit2Navigation';
import Unit3 from './Unit3/Unit3Nav/Unit3Navigation';
import Unit4 from './Unit4/Unit4Nav/Unit4Navigation';
import Module1 from './Unit1/Module1/Module1World';
import Module1Nav from './Unit1/Module1/Module1Nav';
import Module2 from './Unit1/Module2/Module2World';
import Module2Nav from './Unit1/Module2/Module2Nav';
import Module2Practice from './Unit1/Module2/ListeningPractice';
import Module3 from './Unit1/Module3/Module3World';
import Module3Nav from './Unit1/Module3/Module3Nav';
import Module4 from './Unit1/Module4/Module4World';
import Module4Nav from './Unit1/Module4/Module4Nav';
import Module5 from './Unit1/Module5/Module5World';
import Module5Nav from './Unit1/Module5/Module5Nav';
import Module6 from './Unit2/Module6/Module6World';
import Module6Nav from './Unit2/Module6/Module6Nav';
import Module7 from './Unit2/Module7/Module7World';
import Module7Nav from './Unit2/Module7/Module7Nav';
import Module8 from './Unit2/Module8/Module8World';
import Module8Nav from './Unit2/Module8/Module8Nav';
import Module9 from './Unit2/Module9/Module9World';
import Module9Nav from './Unit2/Module9/Module9Nav';
import Module10 from './Unit2/Module10/Module10World';
import Module10Nav from './Unit2/Module10/Module10Nav';
import Module11 from './Unit3/Module11/Module11World';
import Module11Nav from './Unit3/Module11/Module11Nav';
import Module12 from './Unit3/Module12/Module12World';
import Module12Nav from './Unit3/Module12/Module12Nav';
import Module13 from './Unit3/Module13/Module13World';
import Module13Nav from './Unit3/Module13/Module13Nav';
import Module14 from './Unit3/Module14/Module14World';
import Module14Nav from './Unit3/Module14/Module14Nav';
import Module15 from './Unit3/Module15/Module15World';
import Module15Nav from './Unit3/Module15/Module15Nav';
import Module16 from './Unit4/Module16/Module16World';
import Module16Nav from './Unit4/Module16/Module16Nav';
import Module17 from './Unit4/Module17/Module17World';
import Module17Nav from './Unit4/Module17/Module17Nav';
import Module18 from './Unit4/Module18/Module18World';
import Module18Nav from './Unit4/Module18/Module18Nav';
import Module19 from './Unit4/Module19/Module19World';
import Module19Nav from './Unit4/Module19/Module19Nav';
import Module20 from './Unit4/Module20/Module20World';
import Module20Nav from './Unit4/Module20/Module20Nav';
import FreePlay from './FreePlay/FreePlay';
import Level1 from './FreePlay/Level1/Level1';
import Level2 from './FreePlay/Level2/Level2';
import Level3 from './FreePlay/Level3/Level3';
import Level4 from './FreePlay/Level4/Level4';
import Decorate1 from './FreePlay/Level1/Level1';
import Decorate2 from './FreePlay/Level2/Level2';
import Decorate3 from './FreePlay/Level3/Level3';   
import Decorate4 from './FreePlay/Level4/Level4';
import Example from './videos/example';

import { handleError } from './Error';
import { AuthenticatedRoute } from './AuthenticatedRoute/AuthenticatedRoute';
import React, { useState, useEffect } from 'react';
import { AppContext } from './Lib/contextLib';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useIdleTimer } from 'react-idle-timer';
//dialog
import { createTheme, ThemeProvider } from '@mui/material/styles';
import MediaOnboardingDialog from './MediaOnboardingDialog/MediaOnboardingDialog';

const SAFARI_DISMISSED_KEY = 'waf_safari_notice_dismissed';
const SUPPORT_EMAIL = 'support@wearefriends.cool';
const CHROME_DOWNLOAD_URL = 'https://www.google.com/chrome/';
const CHROME_APP_STORE_URL = 'https://apps.apple.com/app/google-chrome/id535886823';

// Returns 'desktop' or 'mobile' when running in Safari, otherwise null.
function getSafariPlatform(isIOSDevice) {
  const userAgent = navigator.userAgent;
  const isSafari =
    /safari/i.test(userAgent) &&
    /apple/i.test(navigator.vendor || '') &&
    !/chrome|chromium|crios|fxios|edg|edgios|opr|opios/i.test(userAgent);
  if (!isSafari) {
    return null;
  }
  return isIOSDevice ? 'mobile' : 'desktop';
}

async function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
}

const safariStyles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: '#F4F6FF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflowY: 'auto',
    zIndex: 9999,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: '#0a2463',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '24px',
    boxShadow: '0 12px 40px rgba(10, 36, 99, 0.12)',
    textAlign: 'center',
    boxSizing: 'border-box',
    width: '100%',
  },
  logo: {
    height: '72px',
    marginBottom: '20px',
  },
  title: {
    margin: '0 0 12px',
    fontWeight: 700,
    lineHeight: 1.25,
  },
  subtitle: {
    margin: '0 0 28px',
    fontSize: '17px',
    lineHeight: 1.5,
    color: '#4a5578',
  },
  steps: {
    listStyle: 'none',
    padding: 0,
    margin: '0 auto 32px',
    textAlign: 'left',
    maxWidth: '400px',
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    marginBottom: '14px',
    fontSize: '16px',
  },
  stepNumber: {
    flexShrink: 0,
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: '#CFDBFF',
    color: '#5568E5',
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  primaryButton: {
    display: 'block',
    width: '100%',
    padding: '14px 24px',
    borderRadius: '999px',
    border: 'none',
    backgroundColor: '#5568E5',
    color: 'white',
    fontSize: '17px',
    fontWeight: 700,
    textDecoration: 'none',
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  secondaryButton: {
    display: 'block',
    width: '100%',
    marginTop: '12px',
    padding: '13px 24px',
    borderRadius: '999px',
    border: '2px solid #5568E5',
    backgroundColor: 'white',
    color: '#5568E5',
    fontSize: '17px',
    fontWeight: 700,
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  helperText: {
    margin: '18px 0 0',
    fontSize: '15px',
    lineHeight: 1.5,
    color: '#4a5578',
  },
  link: {
    color: '#5568E5',
    fontWeight: 600,
  },
  continueButton: {
    marginTop: '24px',
    background: 'none',
    border: 'none',
    color: '#7a83a3',
    fontSize: '14px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  footer: {
    marginTop: '24px',
    fontSize: '13px',
    color: '#7a83a3',
  },
};

function SafariBlocker({ platform, onContinue }) {
  const [copied, setCopied] = useState(false);
  const isMobile = platform === 'mobile';
  const pageUrl = window.location.href;

  const handleCopy = async () => {
    try {
      await copyToClipboard(pageUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (error) {
      window.prompt('Copy this link:', pageUrl);
    }
  };

  const chromeAppUrl = pageUrl.replace(/^https?:\/\//, (scheme) =>
    scheme.startsWith('https') ? 'googlechromes://' : 'googlechrome://'
  );
  const copyLabel = copied ? 'Link copied!' : 'Copy link';

  return (
    <div
      style={{ ...safariStyles.overlay, padding: isMobile ? '16px' : '32px' }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="safari-notice-title"
    >
      <div
        style={{
          ...safariStyles.card,
          maxWidth: isMobile ? '420px' : '560px',
          padding: isMobile ? '32px 24px' : '48px 56px',
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/WAF_Mark.png`}
          alt="We Are Friends"
          style={safariStyles.logo}
        />
        <h1
          id="safari-notice-title"
          style={{ ...safariStyles.title, fontSize: isMobile ? '26px' : '30px' }}
        >
          Let’s get you set up in Chrome
        </h1>

        {isMobile ? (
          <>
            <p style={safariStyles.subtitle}>
              Our lessons use video, music and interactive activities that run
              best in the Chrome app.
            </p>
            <a href={chromeAppUrl} style={safariStyles.primaryButton}>
              Open in Chrome
            </a>
            <button type="button" onClick={handleCopy} style={safariStyles.secondaryButton}>
              {copyLabel}
            </button>
            <p style={safariStyles.helperText}>
              Don’t have Chrome yet?{' '}
              <a
                href={CHROME_APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={safariStyles.link}
              >
                Get it free from the App Store
              </a>
              , then tap Open in Chrome again.
            </p>
          </>
        ) : (
          <>
            <p style={safariStyles.subtitle}>
              The We Are Friends lessons use video, music and interactive
              activities that run best in Google Chrome. It only takes a moment
              to switch.
            </p>
            <ol style={safariStyles.steps}>
              {[
                'Copy the link to this page',
                'Open Google Chrome on your computer',
                'Paste the link into the address bar and sign in',
              ].map((text, index) => (
                <li key={text} style={safariStyles.step}>
                  <span style={safariStyles.stepNumber}>{index + 1}</span>
                  <span>{text}</span>
                </li>
              ))}
            </ol>
            <button type="button" onClick={handleCopy} style={safariStyles.primaryButton}>
              {copyLabel}
            </button>
            <p style={safariStyles.helperText}>
              Don’t have Chrome?{' '}
              <a
                href={CHROME_DOWNLOAD_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={safariStyles.link}
              >
                Get it free
              </a>
            </p>
          </>
        )}

        {/* <button type="button" onClick={onContinue} style={safariStyles.continueButton}>
          Continue in Safari anyway
        </button> */}

        <div style={safariStyles.footer}>
          © 2026 Teaching It Right, LLC
          {!isMobile && (
            <>
              {' · '}Questions?{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} style={safariStyles.link}>
                Contact support
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export function App() {
  if (window.location.hostname === 'www.wearefriends.cool') {
    window.location.href = 'https://wearefriends.cool';
  }
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [countDown, setCountDown] = useState(60*60);
  document.title = 'We Are Friends';
  const handleOnIdle = () => {
    window.alert('Connection is lost. Please login again.');
    // dispatch({ type: 'CLEAR' });
    // navigate('/');
    window.location.reload(false);
  };
  const { getRemainingTime, getElapsedTime, getLastActiveTime } = useIdleTimer({
    // change back to 5 minutes
    timeout: 1000 * 60 * 10,
    onIdle: handleOnIdle,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange',
    ],
  });

  const [isIdle, setIsIdle] = useState(true);
  const [remaining, setRemaining] = useState(0);

  const safariPlatform = getSafariPlatform(isIOS());
  const [safariDismissed, setSafariDismissed] = useState(
    () => sessionStorage.getItem(SAFARI_DISMISSED_KEY) === 'true'
  );
  const dismissSafariNotice = () => {
    sessionStorage.setItem(SAFARI_DISMISSED_KEY, 'true');
    setSafariDismissed(true);
  };

  const theme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 20 },
        },
      },
      MuiDialog: {
        styleOverrides: {
          root: {
            borderRadius: 20,
          },
          paper: { borderRadius: 20, padding: 30 },
        },
      },
    },
    palette: {
      primary: {
        main: '#5568E5',
        dark: '#0a2463',
      },
      secondary: {
        main: '#CFDBFF',
      },
    },
    typography: {
      button: {
        textTransform: 'none',
      },
    },
  });

  function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  return (
    <>
      {safariPlatform && !safariDismissed && (
        <SafariBlocker platform={safariPlatform} onContinue={dismissSafariNotice} />
      )}
      <DndProvider backend={HTML5Backend}>
        <AppContext.Provider value={{ isAuthenticated, userHasAuthenticated }}>
          {isAuthenticated && !isIOS() && <ThemeProvider theme={theme}>
            <MediaOnboardingDialog />
          </ThemeProvider>}
          <Routes>
            <Route exact path='/example' element={<Example />} />
            <Route exact path='*' element={<handleError type= 'page' />} />
            <Route exact path='/' element={<LoginPage />} />
            <Route exact path='/login' element={<QrLoginPage />} />
            <Route exact path='/error' element={<handleError type='page' />} />
            <Route exact path='/terms' element={<TermsPage />} />
            <Route exact path='/privacy' element={<PrivacyPage />} />
            <Route exact path='/' element={<AuthenticatedRoute />}>
              <Route exact path='/unitPage' element={<UnitPage />} />
              <Route exact path='/redo' element={<RedoPage />} />
              <Route exact path='/unit1' element={<Unit1 />} />
              <Route exact path='/unit2' element={<Unit2 />} />
              <Route exact path='/unit3' element={<Unit3 />} />
              <Route exact path='/unit4' element={<Unit4 />} />
              <Route
                exact
                path='/eye-contact/navigation'
                element={<Module1Nav />}
              />
              <Route exact path='/eye-contact' element={<Module1 />} />
              <Route exact path='/listening' element={<Module2 />} />
              <Route
                exact
                path='/listening/practice'
                element={<Module2Practice />}
              />
              <Route
                exact
                path='/listening/navigation'
                element={<Module2Nav />}
              />
              <Route exact path='/facial-expression' element={<Module3 />} />
              <Route
                exact
                path='/facial-expression/navigation'
                element={<Module3Nav />}
              />
              <Route exact path='/posture' element={<Module4 />} />
              <Route
                exact
                path='/posture/navigation'
                element={<Module4Nav />}
              />
              <Route exact path='/distance' element={<Module5 />} />
              <Route
                exact
                path='/distance/navigation'
                element={<Module5Nav />}
              />
              <Route exact path='/greet' element={<Module6 />} />
              <Route exact path='/greet/navigation' element={<Module6Nav />} />
              <Route exact path='/answer' element={<Module7 />} />
              <Route exact path='/answer/navigation' element={<Module7Nav />} />
              <Route exact path='/ask' element={<Module8 />} />
              <Route exact path='/ask/navigation' element={<Module8Nav />} />
              <Route exact path='/respond' element={<Module9 />} />
              <Route
                exact
                path='/respond/navigation'
                element={<Module9Nav />}
              />
              <Route exact path='/close' element={<Module10 />} />
              <Route exact path='/close/navigation' element={<Module10Nav />} />
              <Route exact path='/feelings' element={<Module11 />} />
              <Route
                exact
                path='/feelings/navigation'
                element={<Module11Nav />}
              />
              <Route exact path='/understandfeelings' element={<Module12 />} />
              <Route
                exact
                path='/understandfeelings/navigation'
                element={<Module12Nav />}
              />
              <Route exact path='/changefeelings' element={<Module13 />} />
              <Route
                exact
                path='/changefeelings/navigation'
                element={<Module13Nav />}
              />
              <Route exact path='/solutions' element={<Module14 />} />
              <Route
                exact
                path='/solutions/navigation'
                element={<Module14Nav />}
              />
              <Route exact path='/activelistening' element={<Module15 />} />
              <Route
                exact
                path='/activelistening/navigation'
                element={<Module15Nav />}
              />
              <Route exact path='/manners' element={<Module16 />} />
              <Route
                exact
                path='/manners/navigation'
                element={<Module16Nav />}
              />
              <Route exact path='/friendsbullies' element={<Module17 />} />
              <Route
                exact
                path='/friendsbullies/navigation'
                element={<Module17Nav />}
              />
              <Route exact path='/resolveconflict' element={<Module18 />} />
              <Route
                exact
                path='/resolveconflict/navigation'
                element={<Module18Nav />}
              />
              <Route exact path='/selfadvocacy' element={<Module19 />} />
              <Route
                exact
                path='/selfadvocacy/navigation'
                element={<Module19Nav />}
              />
              <Route exact path='/caring' element={<Module20 />} />
              <Route
                exact
                path='/caring/navigation'
                element={<Module20Nav />}
              />
              <Route exact path='/freeplay' element={<FreePlay level={0}/>} />
              <Route exact path='/freeplay_2' element={<FreePlay level={1}/>} />
              <Route exact path='/freeplay_3' element={<FreePlay level={2}/>} />
              <Route exact path='/freeplay_4' element={<FreePlay level={3}/>} />
              <Route exact path='/freeplay/level1' element={<Level1 />} />
              <Route exact path='/freeplay/level1/decorate' element={<Decorate1 decorate={true}/>} />
              <Route exact path='/freeplay/level1/decorate/store' element={<Decorate1 store={true}/>} />
              <Route exact path='/freeplay/level2' element={<Level2 />} />
              <Route exact path='/freeplay/level2/decorate' element={<Decorate2 decorate={true}/>} />
              <Route exact path='/freeplay/level2/decorate/store' element={<Decorate2 store={true}/>} />
              <Route exact path='/freeplay/level3' element={<Level3 />} />
              <Route exact path='/freeplay/level3/decorate' element={<Decorate3 decorate={true}/>} />
              <Route exact path='/freeplay/level3/decorate/store' element={<Decorate3 store={true}/>} />
              <Route exact path='/freeplay/level4' element={<Level4 />} />
              <Route exact path='/freeplay/level4/decorate' element={<Decorate4 decorate={true}/>} />
              <Route exact path='/freeplay/level4/decorate/store' element={<Decorate4 store={true}/>} />
            </Route>
          </Routes>
        </AppContext.Provider>
      </DndProvider>
    </>
  );
}
